module.exports = __webpack_public_path__ + "static/media/collingwood-logo.1f69bfb3.svg";